<script>
import OfferPrice from '@/components/OfferPrice.vue';
import Button from '@/components/Button.vue';
import Input from '@/components/Input.vue';
import MinusIcon from '~/static/fonts/LineIcons/minus.svg';
import PlusIcon from '~/static/fonts/LineIcons/plus.svg';

export default {
    components: {
        Input,
        Button,
        MinusIcon,
        PlusIcon,
        OfferPrice,
    },
    props: {
        addOn: {
            type: Object,
            required: true,
        },
        isSelected: {
            type: Boolean,
            default: false,
        },
        isLoading: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            quantity: 1,
        };
    },
    computed: {
        quantityInput: {
            get() {
                return this.quantity;
            },
            set(value) {
                this.updateQuantity(value);
            },
        },
    },
    methods: {
        selectAddOn() {
            this.$emit('selected', this.quantity);
        },
        toggleAddOn() {
            if (this.isSelected) {
                this.quantity = 0;
                this.selectAddOn();
            } else {
                this.quantity = 1;
                this.selectAddOn();
            }
        },
        updateQuantity(value) {
            this.quantity = value;
            this.selectAddOn();
        },
    },
};
</script>

<template>
    <div>
        <div
            :class="{ 'add-on-button--active': isSelected, 'add-on-button--disabled': !addOn.is_in_stock}"
            class="add-on-button flex flex-col items-center text-center mb-2"
            @click="toggleAddOn()"
        >
            <img
                v-if="addOn.image?.sizes?.small"
                :src="addOn.image.sizes.small"
                alt=""
                class="block"
            >
            <div class="text-primary sr-only">
                {{ addOn.name }}
            </div>
            <div v-if="addOn.price !== 0">
                <OfferPrice
                    :price="addOn.price"
                />
            </div>
            <div
                v-if="!addOn.is_in_stock"
                class="mt-auto"
            >
                <div class="text-red-light uppercase text-xs font-semibold">
                    Sold out
                </div>
            </div>

        </div>
        <div
            v-if="isSelected"
            class="flex items-center"
        >
            <button
                :disabled="isLoading"
                class="button rounded-tl rounded-bl"
                @click="updateQuantity(quantity - 1)"
            >
                <MinusIcon class="icon" />
            </button>
            <Input
                v-model="quantity"
                :disabled="isLoading"
                type="number"
                class="input text-sm"
                :min="0"
            />
            <button
                :disabled="isLoading"
                class="button rounded-tr rounded-br"
                @click="updateQuantity(quantity + 1)"
            >
                <PlusIcon class="icon" />
            </button>
        </div>
    </div>

</template>

<style scoped lang="scss">
.button {
    @apply bg-primary text-white cursor-pointer transition-fast p-2 w-10;
    height: 2.75rem;
    &:disabled {
        @apply pointer-events-none opacity-50;
    }
    &:hover {
        @apply opacity-75 shadow-md;
    }
}

.input {
    @apply w-full h-full text-center text-primary font-semibold;
    &:focus {
        @apply outline-none;
    }
    &::-webkit-inner-spin-button,
    &::-webkit-outer-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }
}

.add-on-button {
    @apply text-sm cursor-pointer transition-fast select-none;

    img {
        @apply rounded-lg border-4 border-transparent;
    }

    &--active {
        img {
            @apply border-primary;
        }
    }

    @media (min-width: config("theme.screens.md")) {
        &:hover {
            @apply bg-primary text-white;
        }
    }

    &--disabled {
        @apply text-grey;
        cursor: default;

        span, img {
            opacity: 0.35;
        }

        &:hover {
            @apply bg-transparent text-grey;
        }
    }
}
</style>
